import React from 'react'

const SortPanel = ({
    children,
    title = 'Сортировка',
    className = '',
}) => {
    return (
        <section className={['sortPanel', className].filter(Boolean).join(' ')}>
            {title ? <div className="sortPanel__caption">{title}</div> : null}
            {children}
        </section>
    )
}

export default SortPanel
